import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChargeDiscrepancy } from 'services/invoiceDiscrepancies/types';
import { formatCurrency } from 'support/helpers/currency/currency';

type ChargeDiscrepancyViewProps = {
  data: ChargeDiscrepancy['data'];
  currency: ChargeDiscrepancy['currency'];
};

export const ChargeDiscrepancyView: React.FC<ChargeDiscrepancyViewProps> = ({ data, currency }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <p className="text-gray-700">
        {t('invoiceVerification:detailsPage.discrepanciesModal.content.chargeDescription', {
          value: formatCurrency(data.actual?.amount ?? 0, currency),
        })}
      </p>
    </div>
  );
};
